import * as i from "react";
import { p as v } from "./index-efd35e77.js";
import { c as _t, b as wt, a as Mt } from "./index.es-6889c727.js";
import { R as Ft } from "./Reveal-e2f427f6.js";
import { d as Pt, g as tt, a as Rt } from "./auto-scroll-b2de6e53.js";
import { l as Nt, v as Tt } from "./index-64063129.js";
var R = function() {
  for (var t = [], r = 0; r < arguments.length; r++)
    t[r] = arguments[r];
  var e = {}, n = function(o) {
    return typeof o == "object" ? Object.keys(o).forEach(function(l) {
      e[l] = o[l];
    }) : e[o] = !0;
  }, a = function(o) {
    return o.filter(function(l) {
      return l !== !0 && !!l;
    }).map(function(l) {
      return Array.isArray(l) ? a(l) : n(l);
    });
  };
  return a(t), Object.keys(e).map(function(o) {
    return e[o] && o || null;
  }).filter(function(o) {
    return o !== null;
  }).join(" ");
}, ot = function() {
  var t = "", r, e;
  for (r = 0; r < 32; r++)
    e = Math.random() * 16 | 0, (r === 8 || r === 12 || r === 16 || r === 20) && (t += "-"), t += (r === 12 ? 4 : r === 16 ? e & 3 | 8 : e).toString(16);
  return t;
}, O = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  esc: 27,
  space: 32,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46
}, I = function() {
};
function Lt(t) {
  if (typeof Nt < "u")
    Tt(t);
  else {
    var r = "License activation failed for ".concat(t.name, `
`);
    r += `The @progress/kendo-licensing script is not loaded.
`, r += "See ".concat(t.licensingDocsUrl, ` for more information.
`), console.warn(r);
  }
}
function Ee(t, r, e, n) {
  if (t) {
    var a = {
      syntheticEvent: r,
      nativeEvent: r.nativeEvent,
      target: e
    };
    t.call(void 0, Object.assign(a, n));
  }
}
var jt = function(t, r, e) {
  e === void 0 && (e = {});
  var n = i.useCallback(function(f) {
    e.onMouseDown && e.onMouseDown.call(void 0, f), t.onMouseDown && t.onMouseDown.call(void 0, {
      target: r.current,
      syntheticEvent: f
    });
  }, [e.onMouseDown, t.onMouseDown, r]), a = i.useCallback(function(f) {
    e.onMouseUp && e.onMouseUp.call(void 0, f), t.onMouseUp && t.onMouseUp.call(void 0, {
      target: r.current,
      syntheticEvent: f
    });
  }, [e.onMouseUp, t.onMouseUp, r]), o = i.useCallback(function(f) {
    e.onClick && e.onClick.call(void 0, f), t.onClick && t.onClick.call(void 0, {
      target: r.current,
      syntheticEvent: f
    });
  }, [e.onClick, t.onClick, r]), l = i.useCallback(function(f) {
    e.onDoubleClick && e.onDoubleClick.call(void 0, f), t.onDoubleClick && t.onDoubleClick.call(void 0, {
      target: r.current,
      syntheticEvent: f
    });
  }, [e.onDoubleClick, t.onDoubleClick, r]), c = i.useCallback(function(f) {
    e.onMouseEnter && e.onMouseEnter.call(void 0, f), t.onMouseEnter && t.onMouseEnter.call(void 0, {
      target: r.current,
      syntheticEvent: f
    });
  }, [e.onMouseEnter, t.onMouseEnter, r]), u = i.useCallback(function(f) {
    e.onMouseLeave && e.onMouseLeave.call(void 0, f), t.onMouseLeave && t.onMouseLeave.call(void 0, {
      target: r.current,
      syntheticEvent: f
    });
  }, [e.onMouseLeave, t.onMouseLeave, r]), h = i.useCallback(function(f) {
    e.onMouseMove && e.onMouseMove.call(void 0, f), t.onMouseMove && t.onMouseMove.call(void 0, {
      target: r.current,
      syntheticEvent: f
    });
  }, [e.onMouseMove, t.onMouseMove, r]), d = i.useCallback(function(f) {
    e.onMouseOut && e.onMouseOut.call(void 0, f), t.onMouseOut && t.onMouseOut.call(void 0, {
      target: r.current,
      syntheticEvent: f
    });
  }, [e.onMouseOut, t.onMouseOut, r]), m = i.useCallback(function(f) {
    e.onMouseOver && e.onMouseOver.call(void 0, f), t.onMouseOver && t.onMouseOver.call(void 0, {
      target: r.current,
      syntheticEvent: f
    });
  }, [e.onMouseOver, t.onMouseOver, r]);
  return {
    onClick: o,
    onMouseUp: a,
    onMouseDown: n,
    onDoubleClick: l,
    onMouseEnter: c,
    onMouseLeave: u,
    onMouseMove: h,
    onMouseOut: d,
    onMouseOver: m
  };
}, lt = {
  default: "",
  xsmall: "k-icon-xs",
  small: "k-icon-sm",
  medium: "k-icon-md",
  large: "k-icon-lg",
  xlarge: "k-icon-xl",
  xxlarge: "k-icon-xxl",
  xxxlarge: "k-icon-xxxl"
}, ke = globalThis && globalThis.__assign || function() {
  return ke = Object.assign || function(t) {
    for (var r, e = 1, n = arguments.length; e < n; e++) {
      r = arguments[e];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, ke.apply(this, arguments);
}, Ut = globalThis && globalThis.__rest || function(t, r) {
  var e = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && r.indexOf(n) < 0 && (e[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(t); a < n.length; a++)
      r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[a]) && (e[n[a]] = t[n[a]]);
  return e;
}, xe = i.forwardRef(function(t, r) {
  var e = t.className, n = t.name, a = t.themeColor, o = t.size, l = t.flip, c = t.style, u = t.id, h = t.tabIndex, d = Ut(t, ["className", "name", "themeColor", "size", "flip", "style", "id", "tabIndex"]), m = i.useRef(null), f = i.useRef(null);
  i.useImperativeHandle(m, function() {
    return {
      element: f.current
    };
  }), i.useImperativeHandle(r, function() {
    return m.current;
  });
  var _ = i.useMemo(function() {
    return o || nt.size;
  }, [o]), C = i.useMemo(function() {
    return l || nt.flip;
  }, [l]), L = i.useMemo(function() {
    var k;
    return R("k-icon", "k-font-icon", n && Kt(n), (k = {}, k["k-color-".concat(a)] = a, k["k-flip-h"] = C === "horizontal" || C === "both", k["k-flip-v"] = C === "vertical" || C === "both", k), lt[_], e);
  }, [n, a, _, C, e]), w = jt(t, m);
  return i.createElement("span", ke({ ref: f }, d, w, { className: L, id: u, tabIndex: h, style: c, role: "presentation" }));
});
xe.propTypes = {
  style: v.object,
  classNames: v.string,
  name: v.string,
  themeColor: v.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: v.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: v.oneOf(["default", "horizontal", "vertical", "both"])
};
var nt = {
  size: "default",
  flip: "default"
};
xe.displayName = "KendoIcon";
var T = globalThis && globalThis.__assign || function() {
  return T = Object.assign || function(t) {
    for (var r, e = 1, n = arguments.length; e < n; e++) {
      r = arguments[e];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, T.apply(this, arguments);
}, At = globalThis && globalThis.__rest || function(t, r) {
  var e = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && r.indexOf(n) < 0 && (e[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(t); a < n.length; a++)
      r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[a]) && (e[n[a]] = t[n[a]]);
  return e;
}, Oe = i.forwardRef(function(t, r) {
  var e = t.children, n = t.className, a = t.svgClassName, o = t.icon, l = t.flip, c = t.id, u = t.tabIndex, h = t.size, d = t.style, m = t.svgStyle, f = t.themeColor, _ = t.viewBox;
  t.name;
  var C = t.onClick, L = At(t, ["children", "className", "svgClassName", "icon", "flip", "id", "tabIndex", "size", "style", "svgStyle", "themeColor", "viewBox", "name", "onClick"]), w = i.useRef(null);
  i.useImperativeHandle(r, function() {
    return {
      element: w.current
    };
  });
  var k = i.useMemo(function() {
    return o ? o.name : J.icon;
  }, [o]), b = i.useMemo(function() {
    return h || J.size;
  }, [h]), M = i.useMemo(function() {
    return l || J.flip;
  }, [l]), D = i.useMemo(function() {
    return _ || J.viewBox;
  }, [_]), Y = i.useMemo(function() {
    var N;
    return R("k-icon", "k-svg-icon", "k-svg-i-" + k, (N = {}, N["k-color-".concat(f)] = f, N["k-flip-h"] = M === "horizontal" || M === "both", N["k-flip-v"] = M === "vertical" || M === "both", N), lt[b], n);
  }, [k, f, b, M, n]), F = i.useMemo(function() {
    return t.width && t.height ? T({ width: t.width, height: t.height }, d) : t.width ? T({ width: t.width, height: t.width }, d) : t.height ? T({ width: t.height, height: t.height }, d) : T({}, d);
  }, [t.width, t.height, d]);
  return i.createElement(
    "span",
    { className: Y, style: F, ref: w, onClick: C },
    i.createElement("svg", T({ id: c, className: a, style: m, "aria-hidden": !0, tabIndex: u, focusable: !1, xmlns: "http://www.w3.org/2000/svg", viewBox: o ? o.viewBox : D, dangerouslySetInnerHTML: o ? { __html: o.content } : void 0 }, L), o ? void 0 : e)
  );
});
Oe.propTypes = {
  style: v.object,
  classNames: v.string,
  children: v.any,
  icon: v.object,
  themeColor: v.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: v.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: v.oneOf(["default", "horizontal", "vertical", "both"])
};
var J = {
  size: "default",
  flip: "default",
  icon: "",
  viewBox: "0 0 24 24"
};
Oe.displayName = "KendoSvgIcon";
var st = i.createContext({ type: "svg" });
st.displayName = "KendoReactIconsContext";
var Q = globalThis && globalThis.__assign || function() {
  return Q = Object.assign || function(t) {
    for (var r, e = 1, n = arguments.length; e < n; e++) {
      r = arguments[e];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, Q.apply(this, arguments);
}, zt = globalThis && globalThis.__rest || function(t, r) {
  var e = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && r.indexOf(n) < 0 && (e[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(t); a < n.length; a++)
      r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[a]) && (e[n[a]] = t[n[a]]);
  return e;
}, ut = i.forwardRef(function(t, r) {
  var e, n, a = i.useContext(st), o = a.type, l = a.icons, c = t.icon, u = zt(t, ["icon"]), h = o === "svg" ? ((e = t.icon) === null || e === void 0 ? void 0 : e.name) || t.name : t.name || ((n = t.icon) === null || n === void 0 ? void 0 : n.name);
  h = h && l && l[h] && typeof l[h] == "string" ? l[h] : h;
  var d = h && l && l[h] && typeof l[h] != "string" ? l[h] : c;
  return o === "svg" && d ? i.createElement(Oe, Q({}, t, { icon: d, ref: r })) : i.createElement(xe, Q({}, u, { name: h, ref: r }));
});
ut.displayName = "KendoIconWrap";
var Sn = function(t) {
  return t.replace(/^k-i-/, "");
}, Kt = function(t) {
  return "k-i-" + t;
};
v.shape({
  name: v.string.isRequired,
  content: v.string.isRequired,
  viewBox: v.string.isRequired
});
var rt = function(t, r) {
  var e = i.useContext(t), n = e[0], a = e[1], o = i.useState(r), l = o[0], c = o[1], u = n !== void 0 ? n : l, h = function() {
    for (var d = [], m = 0; m < arguments.length; m++)
      d[m] = arguments[m];
    n !== void 0 ? a.apply(void 0, d) : c(d[0]);
  };
  return [
    u,
    h
  ];
}, Ht = i.createContext([
  void 0,
  I
]), Bt = i.createContext([
  void 0,
  I
]), Xt = i.createContext([[], I, I]), Gt = i.createContext([[], I, I]), Yt = 2e3;
function $t(t, r, e) {
  e === void 0 && (e = {});
  var n = r.onPress, a = n === void 0 ? I : n, o = r.onRelease, l = o === void 0 ? I : o, c = r.onDragStart, u = c === void 0 ? I : c, h = r.onDrag, d = h === void 0 ? I : h, m = r.onDragEnd, f = m === void 0 ? I : m, _ = e.hint, C = _ === void 0 ? null : _, L = e.mouseOnly, w = L === void 0 ? !1 : L, k = e.autoScroll, b = k === void 0 ? !0 : k, M = e.scrollContainer, D = M === void 0 ? null : M, Y = i.useState(!1), F = Y[0], N = Y[1], _e = i.useState(!1), $ = _e[0], Ct = _e[1], ae = rt(Bt)[0], we = rt(Ht), ie = we[0], V = we[1], Me = i.useContext(Gt)[0], oe = i.useContext(Xt), Fe = oe[0], Pe = oe[1], Re = oe[2], W = i.useRef({ x: 0, y: 0 }), le = i.useRef(), se = i.useRef(!1), Ne = i.useRef(), z = i.useRef(null), ue = i.useRef(!1), Te = i.useRef({ x: 0, y: 0 }), Le = i.useRef({ x: 0, y: 0 }), q = i.useRef({ x: 0, y: 0 }), je = i.useRef({ x: 0, y: 0 }), Ue = i.useRef({ x: 0, y: 0 }), Ae = i.useRef({ x: 0, y: 0 }), yt = !!(typeof window < "u" && window.PointerEvent), ze = !w && yt, P = i.useCallback(function() {
    return t.current && t.current.element ? t.current.element : t.current;
  }, [t]), It = i.useCallback(function() {
    return C && C.current && C.current.element ? C.current.element : C ? C.current : null;
  }, [C]), Ke = i.useCallback(function() {
    return D && D.current && D.current.element ? D.current.element : D ? D.current : null;
  }, [D]), He = i.useCallback(function() {
    return typeof b == "object" && b.boundaryElementRef && b.boundaryElementRef.current && b.boundaryElementRef.current.element ? b.boundaryElementRef.current.element : typeof b == "object" && b.boundaryElementRef && b.boundaryElementRef.current ? b.boundaryElementRef.current : null;
  }, [b]), K = i.useRef(null);
  i.useImperativeHandle(K, function() {
    return {
      element: P(),
      hint: It(),
      onPress: Et,
      onDragStart: xt,
      onDrag: Ot,
      onDragEnd: Dt,
      onRelease: kt,
      data: t.current
    };
  });
  var Z = i.useCallback(function() {
    var s = P();
    return s && s.ownerDocument || document;
  }, [P]), j = i.useCallback(function() {
    var s = Z();
    return s && s.defaultView || window;
  }, [Z]), Be = i.useCallback(function() {
    return {
      drag: ie ? ie.current : null,
      drop: ae ? ae.current : null,
      drags: Fe.map(function(s) {
        return s.current;
      }),
      drops: Me.map(function(s) {
        return s.current;
      }),
      pressed: F,
      ignoreMouse: se.current,
      scrollOffset: Ue.current,
      offset: Te.current,
      pageOffset: Le.current,
      initialScrollOffset: Ae.current,
      clientOffset: q.current,
      initialClientOffset: je.current,
      velocity: W.current,
      autoScroll: !!(typeof b == "object" ? b.enabled !== !1 : b),
      scrollableParent: He(),
      autoScrollDirection: typeof b == "object" ? b.direction : { horizontal: !0, vertical: !0 },
      isScrolling: $
    };
  }, [ie, ae, Fe, Me, F, b, He, $]), Xe = i.useCallback(function(s) {
    N(s);
  }, []), Ge = i.useCallback(function(s) {
    Ct(s);
  }, []), Ye = i.useCallback(function(s) {
    W.current = s;
  }, []), $e = i.useCallback(function(s) {
    Te.current = s;
  }, []), Ve = i.useCallback(function(s) {
    q.current = s;
  }, []), We = i.useCallback(function(s) {
    Le.current = s;
  }, []), qe = i.useCallback(function(s) {
    je.current = s;
  }, []), Ze = i.useCallback(function(s) {
    Ue.current = s;
  }, []), Je = i.useCallback(function(s) {
    Ae.current = s;
  }, []), Et = i.useCallback(function(s) {
    a(s);
  }, [a]), kt = i.useCallback(function(s) {
    l(s);
  }, [l]), xt = i.useCallback(function(s) {
    V(K, { target: t.current, event: s }), u(s);
  }, [V, t, u]), Ot = i.useCallback(function(s) {
    d(s);
  }, [d]), Dt = i.useCallback(function(s) {
    ue.current || (V(null, { target: t.current, event: s }), f(s));
  }, [f, V, t]), g = i.useCallback(function(s) {
    Pt(Be(), { event: s, payload: K.current }, {
      onVelocityChange: Ye,
      onOffsetChange: $e,
      onClientOffsetChange: Ve,
      onPageOffsetChange: We,
      onInitialClientOffsetChange: qe,
      onScrollOffsetChange: Ze,
      onInitialScrollOffsetChange: Je,
      onIsPressedChange: Xe,
      onIsScrollingChange: Ge
    });
  }, [
    Be,
    Ye,
    $e,
    We,
    Ve,
    qe,
    Je,
    Xe,
    Ze,
    Ge
  ]), ce = i.useCallback(function(s) {
    g(s);
  }, [g]), de = i.useCallback(function(s) {
    g(s);
  }, [g]), fe = i.useCallback(function(s) {
    g(s);
  }, [g]), he = i.useCallback(function(s) {
    g(s);
  }, [g]), ve = i.useCallback(function(s) {
    g(s);
  }, [g]), me = i.useCallback(function(s) {
    g(s);
  }, [g]), ge = i.useCallback(function(s) {
    g(s);
  }, [g]), pe = i.useCallback(function(s) {
    s.preventDefault(), g(s);
  }, [g]), be = i.useCallback(function(s) {
    s.preventDefault(), g(s);
  }, [g]), Ce = i.useCallback(function(s) {
    s.preventDefault(), g(s);
  }, [g]), ye = i.useCallback(function(s) {
    if (s.touches.length === 0 && s.changedTouches.length === 1) {
      var p = j();
      se.current = !0, Ne.current = p.setTimeout(function() {
        se.current = !1;
      }, Yt);
    }
    g(s);
  }, [g, j]), Ie = i.useCallback(function(s) {
    g(s);
  }, [g]), Qe = i.useCallback(function() {
    var s = P();
    if (s) {
      var p = s.style.touchAction;
      return s.style.touchAction = "none", function() {
        s.style.touchAction = p;
      };
    }
  }, [P]), et = i.useCallback(function() {
    return Pe(K), function() {
      Re(K);
    };
  }, [Re, Pe]), St = function() {
    var s = j(), p = P(), E = Z();
    return ze ? (p && (z.current = tt(p), z.current && z.current.addEventListener("scroll", Ie, { passive: !0 }), p.addEventListener("pointerdown", ce, { passive: !0 })), F && (E.addEventListener("pointermove", de), E.addEventListener("pointerup", he, !0), E.addEventListener("contextmenu", pe), E.addEventListener("pointercancel", fe, { passive: !0 }))) : (s.addEventListener("touchmove", I, { capture: !1, passive: !1 }), p && (p.addEventListener("mousedown", ve, { passive: !0 }), w || (p.addEventListener("touchstart", be, { passive: !0 }), F && (p.addEventListener("touchmove", Ce, { passive: !0 }), p.addEventListener("touchend", ye, { passive: !0 })))), F && (E.addEventListener("mousemove", me, { passive: !0 }), E.addEventListener("mouseup", ge, { passive: !0 }))), function() {
      z.current && z.current.removeEventListener("scroll", Ie), p && (p.removeEventListener("pointerdown", ce), p.removeEventListener("mousedown", ve), p.removeEventListener("touchstart", be), p.removeEventListener("touchmove", Ce), p.removeEventListener("touchend", ye)), E.removeEventListener("pointermove", de), E.removeEventListener("pointerup", he, !0), E.removeEventListener("contextmenu", pe), E.removeEventListener("pointercancel", fe), E.removeEventListener("mousemove", me), E.removeEventListener("mouseup", ge), s.removeEventListener("touchmove", I), s.clearTimeout(Ne.current);
    };
  };
  i.useEffect(function() {
    var s = j();
    if ($) {
      var p = Ke() || tt(document.elementFromPoint(q.current.x, q.current.y));
      s.clearInterval(le.current), le.current = s.setInterval(function() {
        Rt(p, { x: W.current.x, y: W.current.y });
      }, 50);
    }
    return function() {
      s.clearInterval(le.current);
    };
  }, [P, Ke, j, $]), i.useEffect(Qe, [Qe]), i.useEffect(St, [
    F,
    j,
    P,
    Z,
    w,
    ze,
    pe,
    ve,
    me,
    ge,
    fe,
    ce,
    de,
    he,
    ye,
    Ce,
    be,
    Ie
  ]), i.useEffect(function() {
    return ue.current = !1, function() {
      ue.current = !0;
    };
  }, []), i.useLayoutEffect(et, [et]);
}
var ct = i.forwardRef(function(t, r) {
  var e = i.useRef(null), n = i.useRef(null), a = i.useCallback(function() {
    return e.current && e.current.element ? e.current.element : e.current;
  }, [e]);
  i.useImperativeHandle(n, function() {
    return { element: a() || null };
  }), i.useImperativeHandle(r, function() {
    return n.current;
  }), i.useImperativeHandle(t.childRef, function() {
    return e.current;
  });
  var o = i.useCallback(function(d) {
    t.onPress && t.onPress({
      element: a(),
      target: n.current,
      event: d
    });
  }, [a, t.onPress]), l = i.useCallback(function(d) {
    t.onRelease && t.onRelease({
      element: a(),
      target: n.current,
      event: d
    });
  }, [a, t.onRelease]), c = i.useCallback(function(d) {
    t.onDragStart && t.onDragStart({
      element: a(),
      target: n.current,
      event: d
    });
  }, [t, a]), u = i.useCallback(function(d) {
    t.onDrag && t.onDrag({
      element: a(),
      target: n.current,
      event: d
    });
  }, [a, t.onDrag]), h = i.useCallback(function(d) {
    t.onDragEnd && t.onDragEnd({
      element: a(),
      target: n.current,
      event: d
    });
  }, [a, t.onDragEnd]);
  return $t(e, {
    onPress: o,
    onRelease: l,
    onDragStart: c,
    onDrag: u,
    onDragEnd: h
  }, {
    mouseOnly: t.mouseOnly,
    autoScroll: t.autoScroll,
    hint: t.hint,
    scrollContainer: t.scrollContainer
  }), t.children ? i.cloneElement(i.Children.only(t.children), { ref: e }) : null;
});
ct.displayName = "KendoReactDraggable";
var dt = {
  sizeMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  },
  roundedMap: {
    small: "sm",
    medium: "md",
    large: "lg"
  }
}, ne = "", ft = "0", x = "_";
function re(t, r, e) {
  if (A(t))
    return r[Number(t)];
  var n = r[Number(X(t))], a = n && n[e] || [];
  return a.length ? re(G(t), a, e) : void 0;
}
function X(t) {
  return ht(t) ? t : t.split(x)[0];
}
function G(t) {
  if (ht(t))
    return t;
  var r = t.indexOf(x);
  return t.substring(r + 1);
}
function at(t) {
  return S("0", t);
}
function S(t, r) {
  return t = t.toString(), r ? r + x + t : t;
}
function ee(t) {
  var r = t.lastIndexOf(x);
  return r < 0 ? ne : t.substring(0, r);
}
function ht(t) {
  return t === ne || t.indexOf(x) < 0;
}
function A(t) {
  return t !== ne && t.indexOf(x) < 0;
}
function vt(t) {
  return t.split(x);
}
function De(t) {
  var r = t.lastIndexOf(x);
  return r < 0 ? t : t.substring(r + 1);
}
function _n(t, r) {
  var e = r;
  t = "r" + x + t, r = "r" + x + r;
  var n = ee(t) + x;
  if (r.startsWith(n)) {
    var a = r.substring(n.length);
    if (a) {
      var o = X(a);
      if (Number(De(t)) < Number(o)) {
        var l = n + (Number(o) - 1).toString() + a.substring(o.length);
        return G(l);
      }
    }
  }
  return e;
}
var Vt = 5e4, Wt = (
  /** @class */
  function() {
    function t() {
      this.objects = [];
    }
    return t.prototype.init = function(r) {
      for (var e, n = 0; n < r.length; n++)
        n % Vt === 0 && (e = {}, this.objects.push(e)), e[r[n]] = !0;
    }, t.prototype.hasId = function(r) {
      return this.objects.some(function(e) {
        return e[r];
      });
    }, t;
  }()
);
const qt = Wt;
function y(t, r) {
  var e = (t || "").split("."), n = r;
  return e.forEach(function(a) {
    n = n ? n[a] : void 0;
  }), n;
}
function wn(t) {
  return t.length !== void 0;
}
var B = globalThis && globalThis.__assign || function() {
  return B = Object.assign || function(t) {
    for (var r, e = 1, n = arguments.length; e < n; e++) {
      r = arguments[e];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, B.apply(this, arguments);
};
function U(t, r) {
  var e = y(r, t);
  return !!(e && e.length);
}
function H(t, r) {
  return r.expanded(t) && U(t, r.getChildrenField());
}
function Zt(t, r, e, n) {
  var a = Jt([t], r, e, n);
  return a.length ? a[0] : void 0;
}
function Jt(t, r, e, n) {
  var a = [], o = new qt();
  return o.init(t), gt(o, r, e, ne, a, n), a;
}
function Qt(t, r, e, n, a) {
  var o, l = Number(X(r));
  if (l >= t.length)
    return t;
  var c = t, u = t[l];
  return u[n] || (c = t.slice(), u = c[l] = Object.assign({}, u, (o = {}, o[n] = !0, o))), A(r) ? e(u) : u[a] && (u[a] = Qt(u[a], G(r), e, n, a)), c;
}
function mt(t, r, e) {
  for (var n = vt(t), a = r, o = 0; o < n.length; o++) {
    var l = a[Number(n[o])];
    if (e.disabled(l))
      return !1;
    a = l[e.getChildrenField()];
  }
  return !0;
}
function Mn(t, r, e, n) {
  return n ? o(t) : a(t, r);
  function a(l, c) {
    for (var u = [], h = l[e] || [], d = 0; d < h.length; d++) {
      var m = S(d, c);
      u.push(m), u = u.concat(a(h[d], m));
    }
    return u;
  }
  function o(l) {
    for (var c = [], u = l[e] || [], h = 0; h < u.length; h++)
      c.push(y(n, u[h])), c = c.concat(o(u[h]));
    return c;
  }
}
function Fn(t, r, e, n, a) {
  var o = t[n] || [];
  return o.every(function(l, c) {
    return a.indexOf(e ? y(e, l) : S(c, r)) > -1;
  });
}
function Pn(t, r, e) {
  for (var n = [], a = vt(t), o = e, l = 0; l < a.length - 1 && o; l++) {
    var c = o[Number(a[l])];
    n.push(c), o = c[r];
  }
  return n;
}
function en(t, r, e) {
  var n = e.slice();
  if (A(t))
    n.splice(Number(t), 1);
  else {
    var a = Number(X(t)), o = n[a] = B({}, n[a]);
    o[r] = en(G(t), r, o[r]);
  }
  return n;
}
function tn(t, r, e, n, a) {
  var o = a.slice();
  if (A(n))
    if (r === "child") {
      var l = o[Number(n)] = B({}, o[Number(n)]);
      l[e] ? (l[e] = l[e].slice(), l[e].push(t)) : l[e] = [t];
    } else
      o.splice(Number(n) + (r === "after" ? 1 : 0), 0, t);
  else {
    var c = Number(X(n)), u = o[c] = B({}, o[c]);
    u[e] = tn(t, r, e, G(n), u[e]);
  }
  return o;
}
function gt(t, r, e, n, a, o) {
  for (var l = 0; l < e.length; l++) {
    var c = e[l], u = S(l, n);
    t.hasId(y(r, c)) && a.push(u), U(c, o) && gt(t, r, y(o, c), u, a, o);
  }
}
function nn(t, r, e, n, a) {
  switch (n) {
    case O.left:
      return o();
    case O.right:
      return l();
    case O.up:
      return c();
    case O.down:
      return u();
    case O.home:
      return ft;
    case O.end:
      return h();
    default:
      return r;
  }
  function o() {
    return A(r) || a.expanded(t) && mt(r, e, a) ? r : ee(r);
  }
  function l() {
    return H(t, a) ? at(r) : r;
  }
  function c() {
    var d = Number(De(r)), m = ee(r);
    return d ? bt(S(d - 1, m), e, a) : A(r) ? r : m;
  }
  function u() {
    return H(t, a) ? at(r) : pt(r, e, a) || r;
  }
  function h() {
    for (var d = (e.length - 1).toString(), m = e[e.length - 1], f; H(m, a); )
      f = m[a.getChildrenField()], d = S(f.length - 1, d), m = f[f.length - 1];
    return d;
  }
}
function pt(t, r, e) {
  var n = ee(t), a = n ? re(n, r, e.getChildrenField()) : void 0, o = a ? a[e.getChildrenField()] : r, l = Number(De(t));
  return l < o.length - 1 ? S(l + 1, n) : a ? pt(n, r, e) : void 0;
}
function bt(t, r, e) {
  var n = re(t, r, e.getChildrenField());
  return H(n, e) ? bt(S(n[e.getChildrenField()].length - 1, t), r, e) : t;
}
var rn = "expanded", an = "text", on = "disabled", it = "items", ln = "hasChildren", sn = "selected", un = "checked", cn = "checkIndeterminate", dn = "_kendoItemId", fn = "_kendoTreeViewGuid", hn = globalThis && globalThis.__extends || function() {
  var t = function(r, e) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var o in a)
        Object.prototype.hasOwnProperty.call(a, o) && (n[o] = a[o]);
    }, t(r, e);
  };
  return function(r, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    t(r, e);
    function n() {
      this.constructor = r;
    }
    r.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), te = globalThis && globalThis.__assign || function() {
  return te = Object.assign || function(t) {
    for (var r, e = 1, n = arguments.length; e < n; e++) {
      r = arguments[e];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, te.apply(this, arguments);
}, vn = dt.sizeMap, mn = i.createContext(function(t) {
  return t;
}), gn = (
  /** @class */
  function(t) {
    hn(r, t);
    function r() {
      var e = t !== null && t.apply(this, arguments) || this;
      return e.itemGuid = ot(), e.onCheckChange = function(n) {
        e.props.onCheckChange(n, e.item, e.itemId);
      }, e.onExpandChange = function(n) {
        e.props.onExpandChange(n, e.item, e.itemId);
      }, e.onItemClick = function(n) {
        e.props.onItemClick(n, e.item, e.itemId);
      }, e.onPress = function(n) {
        e.props.onPress(n.event, e.item, e.itemId);
      }, e.onDrag = function(n) {
        e.props.onDrag(n.event, e.item, e.itemId);
      }, e.onRelease = function(n) {
        e.props.onRelease(n.event, e.item, e.itemId);
      }, e.assignDraggableMeta = function(n) {
        n && (n[dn] = e.props.itemId, n[fn] = e.props.treeGuid);
      }, e;
    }
    return r.prototype.render = function() {
      var e = this, n = this.renderSubitemsIfApplicable(), a = this.renderItemInPart();
      return i.createElement(
        "li",
        { className: R("k-treeview-item"), tabIndex: this.tabIndex, role: "treeitem", "aria-expanded": this.ariaExpanded, "aria-selected": this.ariaSelected, "aria-checked": this.ariaChecked, "aria-disabled": this.disabled ? !0 : void 0, ref: function(o) {
          return e.itemElement = o;
        } },
        i.createElement(
          "div",
          { className: "k-treeview-".concat(this.props.position), ref: this.assignDraggableMeta },
          this.renderExpandIcon(),
          this.renderCheckbox(),
          this.props.draggable ? i.createElement(ct, { onPress: this.onPress, onDrag: this.onDrag, onRelease: this.onRelease }, a) : a
        ),
        this.props.animate ? i.createElement(Ft, { transitionEnterDuration: 200, transitionExitDuration: 200, style: { display: "block" }, children: n }) : n
      );
    }, r.prototype.componentDidMount = function() {
      var e = this.props.focusedItemId, n = this.itemId;
      e && e === n && this.props.onFocusDomElNeeded(this.itemElement), this.checkboxElement && (this.checkboxElement.indeterminate = this.fieldsSvc.checkIndeterminate(this.item));
    }, r.prototype.componentDidUpdate = function(e) {
      var n = this.props.focusedItemId;
      if (n && n !== e.focusedItemId && n === this.itemId && this.props.onFocusDomElNeeded(this.itemElement), this.checkboxElement) {
        var a = this.fieldsSvc.checkIndeterminate(this.item);
        a !== e.fieldsService.checkIndeterminate(e.item) && (this.checkboxElement.indeterminate = a);
      }
    }, r.prototype.renderCheckbox = function() {
      var e, n = this;
      if (this.props.checkboxes) {
        var a = this.props.size;
        return i.createElement(
          "div",
          { className: R("k-checkbox-wrap") },
          i.createElement("input", { type: "checkbox", className: R("k-checkbox k-rounded-md", (e = {}, e["k-checkbox-".concat(vn[a] || a)] = a, e["k-disabled"] = this.disabled, e)), "aria-label": this.item.text, checked: !!this.fieldsSvc.checked(this.item), id: this.itemGuid, tabIndex: -1, onChange: this.onCheckChange, ref: function(o) {
            return n.checkboxElement = o;
          } }),
          i.createElement("label", { className: "k-checkbox-label", htmlFor: this.itemGuid })
        );
      } else
        return;
    }, r.prototype.renderExpandIcon = function() {
      var e = this.props.expandIcons && // If it is explicitly said that the item has children (even not loaded yet)
      // or if the item actually has children, then render the icon.
      (this.fieldsSvc.hasChildren(this.item) || U(this.item, this.fieldsSvc.getChildrenField()));
      return e && // Allowing the toggle-button even with `disabled=true` might be a valid case!
      // Re-evaluate the classes bellow if such scenario occurs
      i.createElement(
        "span",
        { className: R("k-treeview-toggle", { "k-disabled": this.disabled }), onClick: this.onExpandChange },
        i.createElement(ut, te({}, this.getIconProps()))
      );
    }, r.prototype.renderSubitemsIfApplicable = function() {
      var e = this, n = this.fieldsSvc.children(this.item);
      return H(this.item, this.fieldsSvc) ? i.createElement("ul", { className: "k-treeview-group", role: "group" }, n.map(function(a, o) {
        return i.createElement(Se, { item: a, position: o === 0 ? "top" : o === n.length - 1 ? "bot" : "mid", itemId: S(o, e.itemId), treeGuid: e.props.treeGuid, animate: e.props.animate, focusedItemId: e.props.focusedItemId, tabbableItemId: e.props.tabbableItemId, fieldsService: e.props.fieldsService, itemUI: e.props.itemUI, checkboxes: e.props.checkboxes, ariaMultiSelectable: e.props.ariaMultiSelectable, onItemClick: e.props.onItemClick, onFocusDomElNeeded: e.props.onFocusDomElNeeded, draggable: e.props.draggable, onPress: e.props.onPress, onDrag: e.props.onDrag, onRelease: e.props.onRelease, expandIcons: e.props.expandIcons, onExpandChange: e.props.onExpandChange, onCheckChange: e.props.onCheckChange, key: o, size: e.props.size, disabled: e.disabled, isRtl: e.props.isRtl });
      })) : void 0;
    }, r.prototype.renderItemInPart = function() {
      return i.createElement(
        "span",
        { className: R("k-treeview-leaf", {
          "k-focus": this.props.focusedItemId === this.itemId,
          "k-selected": this.fieldsSvc.selected(this.item),
          "k-disabled": this.disabled
        }), style: { touchAction: "none" }, onClick: this.onItemClick },
        i.createElement("span", { className: "k-treeview-leaf-text" }, this.props.itemUI ? i.createElement(this.props.itemUI, { item: this.item, itemHierarchicalIndex: this.itemId }) : this.fieldsSvc.text(this.item))
      );
    }, Object.defineProperty(r.prototype, "fieldsSvc", {
      get: function() {
        return this.props.fieldsService;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "itemId", {
      get: function() {
        return this.props.itemId;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "item", {
      get: function() {
        return this.props.item;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "tabIndex", {
      get: function() {
        return (this.props.focusedItemId || this.props.tabbableItemId) === this.itemId ? 0 : -1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "ariaExpanded", {
      get: function() {
        return this.fieldsSvc.hasChildren(this.item) || U(this.item, this.fieldsSvc.getChildrenField()) ? !!this.fieldsSvc.expanded(this.item) : void 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "disabled", {
      get: function() {
        return this.props.disabled || this.fieldsSvc.disabled(this.item);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "ariaChecked", {
      get: function() {
        if (this.props.checkboxes)
          return this.fieldsSvc.checked(this.item) ? "true" : this.fieldsSvc.checkIndeterminate(this.item) ? "mixed" : "false";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "ariaSelected", {
      get: function() {
        return this.fieldsSvc.selected(this.item) ? !0 : this.props.ariaMultiSelectable ? this.disabled ? void 0 : !1 : void 0;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.getIconProps = function() {
      var e = this.fieldsSvc.expanded(this.item), n = e && !U(this.item, this.fieldsSvc.getChildrenField());
      return n ? { name: "loading" } : e ? { name: "caret-alt-down", icon: _t } : { name: this.props.isRtl ? "caret-alt-left" : "caret-alt-right", icon: this.props.isRtl ? wt : Mt };
    }, r.defaultProps = {
      position: "top"
    }, r;
  }(i.Component)
), Se = i.forwardRef(function(t, r) {
  var e = i.useContext(mn), n = e.call(void 0, t);
  return i.createElement(gn, te({ ref: r }, n));
});
Se.displayName = "TreeViewItem";
var pn = (
  /** @class */
  function() {
    function t(r) {
      this.expandField = r.expandField, this.selectField = r.selectField, this.hasChildrenField = r.hasChildrenField, this.childrenField = r.childrenField, this.textField = r.textField, this.disableField = r.disableField, this.checkField = r.checkField, this.checkIndeterminateField = r.checkIndeterminateField, this.focusIdField = r.focusIdField;
    }
    return t.prototype.expanded = function(r) {
      return y(this.expandField, r);
    }, t.prototype.selected = function(r) {
      return y(this.selectField, r);
    }, t.prototype.text = function(r) {
      return y(this.textField, r);
    }, t.prototype.disabled = function(r) {
      return y(this.disableField, r);
    }, t.prototype.hasChildren = function(r) {
      return y(this.hasChildrenField, r);
    }, t.prototype.children = function(r) {
      var e = y(this.childrenField, r);
      return e || [];
    }, t.prototype.checked = function(r) {
      return y(this.checkField, r);
    }, t.prototype.checkIndeterminate = function(r) {
      return y(this.checkIndeterminateField, r);
    }, t.prototype.focusId = function(r) {
      return this.focusIdField && y(this.focusIdField, r);
    }, t.prototype.getChildrenField = function() {
      return this.childrenField;
    }, t;
  }()
);
const bn = pn;
var Cn = {
  name: "@progress/kendo-react-treeview",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1695801636,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, yn = globalThis && globalThis.__extends || function() {
  var t = function(r, e) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, a) {
      n.__proto__ = a;
    } || function(n, a) {
      for (var o in a)
        Object.prototype.hasOwnProperty.call(a, o) && (n[o] = a[o]);
    }, t(r, e);
  };
  return function(r, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    t(r, e);
    function n() {
      this.constructor = r;
    }
    r.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
  };
}(), In = dt.sizeMap, Rn = (
  /** @class */
  function(t) {
    yn(r, t);
    function r(e) {
      var n = t.call(this, e) || this;
      return n.state = { focusedItemId: void 0, focusedItemPublicId: void 0, tabbableItemId: ft }, n.fieldsSvc = null, n.allowExplicitFocus = !1, n.treeGuid = ot(), n._element = null, n.onFocusDomElNeeded = function(a) {
        n.allowExplicitFocus && n.focusDomItem(a);
      }, n.onCheckChange = function(a, o, l) {
        n.setFocus(l), n.dispatchCheckChange(a, o, l);
      }, n.onExpandChange = function(a, o, l) {
        n.setFocus(l), n.dispatchExpandChange(a, o, l);
      }, n.onPress = function(a, o, l) {
        n.props.onItemDragStart && n.props.onItemDragStart.call(void 0, { target: n, item: o, itemHierarchicalIndex: l });
      }, n.onDrag = function(a, o, l) {
        var c = a.pageX, u = a.pageY, h = a.clientX, d = a.clientY;
        n.props.onItemDragOver && n.props.onItemDragOver.call(void 0, {
          target: n,
          item: o,
          itemHierarchicalIndex: l,
          pageX: c,
          pageY: u,
          clientX: h,
          clientY: d
        });
      }, n.onRelease = function(a, o, l) {
        var c = a.pageX, u = a.pageY, h = a.clientX, d = a.clientY;
        n.props.onItemDragEnd && n.props.onItemDragEnd.call(void 0, {
          target: n,
          item: o,
          itemHierarchicalIndex: l,
          pageX: c,
          pageY: u,
          clientX: h,
          clientY: d
        });
      }, n.onItemClick = function(a, o, l) {
        n.setFocus(l), n.dispatchItemClick(a, o, l);
      }, n.onFocus = function() {
        clearTimeout(n.blurRequest), n.state.focusedItemId === void 0 && n.data.length && n.setFocus(n.state.tabbableItemId);
      }, n.onBlur = function() {
        clearTimeout(n.blurRequest), n.blurRequest = window.setTimeout(function() {
          return n.setFocus(void 0);
        }, 0);
      }, n.onKeyDown = function(a) {
        var o = n.getFocusedItem();
        if (o && n.fieldsSvc) {
          var l = nn(o, n.state.focusedItemId, n.data, a.keyCode, n.fieldsSvc);
          l !== n.state.focusedItemId && (a.preventDefault(), n.allowExplicitFocus = !0, n.setFocus(l)), n.dispatchEventsOnKeyDown(a, o);
        }
      }, Lt(Cn), n;
    }
    return Object.defineProperty(r.prototype, "element", {
      /**
       * @hidden
       */
      get: function() {
        return this._element;
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var e, n = this;
      this.fieldsSvc = new bn(this.props);
      var a = this.props, o = a.size, l = a.className;
      return i.createElement(
        "div",
        { className: R("k-treeview", (e = {}, e["k-treeview-".concat(In[o] || o)] = o, e["k-user-select-none"] = this.props.draggable, e["k-rtl"] = this.props.dir === "rtl", e), l), onKeyDown: this.onKeyDown, onFocus: this.onFocus, onBlur: this.onBlur, role: "tree", "aria-multiselectable": this.ariaMultiSelectable ? !0 : void 0, "aria-label": this.props["aria-label"], "aria-labelledby": this.props["aria-labelledby"], ref: function(c) {
          return n._element = c;
        }, tabIndex: this.props.tabIndex },
        i.createElement("ul", { className: "k-treeview-lines k-treeview-group", role: "group" }, this.data.map(function(c, u) {
          return i.createElement(Se, { item: c, position: u === 0 ? "top" : u === n.data.length - 1 ? "bot" : "mid", itemId: u.toString(), treeGuid: n.treeGuid, animate: n.props.animate, focusedItemId: n.state.focusedItemId, tabbableItemId: n.state.tabbableItemId, fieldsService: n.fieldsSvc, itemUI: n.props.item, checkboxes: n.props.checkboxes, ariaMultiSelectable: n.ariaMultiSelectable, onItemClick: n.onItemClick, onFocusDomElNeeded: n.onFocusDomElNeeded, draggable: n.props.draggable, onPress: n.onPress, onDrag: n.onDrag, onRelease: n.onRelease, expandIcons: n.props.expandIcons, onExpandChange: n.onExpandChange, onCheckChange: n.onCheckChange, key: u, size: o, isRtl: n.props.dir === "rtl" });
        }))
      );
    }, r.prototype.componentDidUpdate = function() {
      this.allowExplicitFocus = !1, this.refocusDueToFocusIdField();
    }, r.prototype.dispatchEventsOnKeyDown = function(e, n) {
      var a = this;
      if (this.fieldsSvc !== null) {
        var o = function() {
          return a.fieldsSvc && mt(a.state.focusedItemId, a.data, a.fieldsSvc);
        };
        e.keyCode === O.left && this.fieldsSvc.expanded(n) && o() ? this.dispatchExpandChange(e, n, this.state.focusedItemId) : e.keyCode === O.right && !this.fieldsSvc.expanded(n) && (this.fieldsSvc.hasChildren(n) || U(n, this.props.childrenField)) && o() ? this.dispatchExpandChange(e, n, this.state.focusedItemId) : e.keyCode === O.enter && o() ? this.dispatchItemClick(e, n, this.state.focusedItemId) : e.keyCode === O.space && o() && (e.preventDefault(), this.dispatchCheckChange(e, n, this.state.focusedItemId));
      }
    }, r.prototype.setFocus = function(e) {
      if (e && this.fieldsSvc)
        if (this.fieldsSvc.focusIdField) {
          var n = this.getItemById(e);
          this.setState({ focusedItemId: e, focusedItemPublicId: this.fieldsSvc.focusId(n) });
        } else
          this.setState({ focusedItemId: e });
      else
        this.setState(function(a) {
          return {
            focusedItemId: void 0,
            focusedItemPublicId: void 0,
            tabbableItemId: a.focusedItemId
          };
        });
    }, r.prototype.getFocusedItem = function() {
      return this.state.focusedItemId ? this.getItemById(this.state.focusedItemId) : void 0;
    }, r.prototype.getItemById = function(e) {
      return re(e, this.data, this.props.childrenField || it);
    }, r.prototype.dispatchCheckChange = function(e, n, a) {
      Ee(this.props.onCheckChange, e, this, { item: n, itemHierarchicalIndex: a });
    }, r.prototype.dispatchExpandChange = function(e, n, a) {
      Ee(this.props.onExpandChange, e, this, { item: n, itemHierarchicalIndex: a });
    }, r.prototype.dispatchItemClick = function(e, n, a) {
      Ee(this.props.onItemClick, e, this, { item: n, itemHierarchicalIndex: a });
    }, r.prototype.refocusDueToFocusIdField = function() {
      if (this.fieldsSvc && this.fieldsSvc.focusIdField) {
        var e = this.state.focusedItemPublicId;
        if (e) {
          var n = this.props.getFocusHierarchicalIndex ? this.props.getFocusHierarchicalIndex(e) : Zt(e, this.fieldsSvc.focusIdField, this.data, this.props.childrenField);
          n !== this.state.focusedItemId && (this.allowExplicitFocus = !0, this.setState({ focusedItemId: n }));
        }
      }
    }, Object.defineProperty(r.prototype, "ariaMultiSelectable", {
      get: function() {
        return this.props["aria-multiselectable"] === !0 || this.props["aria-multiselectable"] === "true";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "data", {
      get: function() {
        return this.props.data || [];
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.focusDomItem = function(e) {
      e.focus();
    }, Object.defineProperty(r.prototype, "guid", {
      /**
       * Returns the `guid` which is associated with the TreeView.
       */
      get: function() {
        return this.treeGuid;
      },
      enumerable: !1,
      configurable: !0
    }), r.propTypes = {
      data: v.arrayOf(v.any),
      animate: v.bool,
      tabIndex: v.number,
      focusIdField: v.string,
      getHierarchicalIndexById: v.func,
      onExpandChange: v.func,
      onItemClick: v.func,
      expandField: v.string,
      selectField: v.string,
      childrenField: v.string,
      hasChildrenField: v.string,
      textField: v.string,
      disableField: v.string,
      item: v.any,
      "aria-multiselectable": function(e, n, a) {
        return e[n] !== void 0 && e[n] !== !0 && e[n] !== !1 && e[n] !== "true" && e[n] !== "false" ? new Error("Invalid prop `" + n + "` supplied to `" + a + "`. Validation failed.") : null;
      },
      "aria-label": v.string,
      "aria-labelledby": v.string,
      size: v.oneOf([null, "small", "medium", "large"]),
      dir: v.string
    }, r.defaultProps = {
      animate: !0,
      expandField: rn,
      selectField: sn,
      hasChildrenField: ln,
      childrenField: it,
      textField: an,
      disableField: on,
      checkField: un,
      checkIndeterminateField: cn,
      size: "medium"
    }, r;
  }(i.Component)
);
export {
  un as C,
  dn as D,
  rn as E,
  ut as I,
  sn as S,
  Rn as T,
  it as a,
  cn as b,
  re as c,
  en as d,
  tn as e,
  _n as f,
  y as g,
  Mn as h,
  wn as i,
  Fn as j,
  ee as k,
  Pn as l,
  R as m,
  fn as n,
  Jt as r,
  Sn as t,
  Qt as u
};
